import styled from 'styled-components'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import { composeTheme } from '../../utils/compose-theme'
import layoutV2 from '../../tokens/v2/layout'

export const Alert = styled.div`
  align-items: center;
  display: block;
  border-radius: ${border.radius.radiusSm};
  border: ${border.width.widthThin} solid;
  box-shadow: 0 0.4rem 1.6rem rgba(0, 0, 0, 0.08);
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightRegular};
  justify-content: space-between;
  line-height: ${typography.fontHeight.lineHeightSm};

  padding: ${layout.padding.spacingInsetXs};
  width: fit-content;
  color: ${colors.neutralColorLowPure};

  &.neutral {
    background-color: ${colors.neutralColorHighLight};
    border: ${border.width.widthHairline} solid;
    border-color: ${colors.neutralColorHighDark};
  }

  &.info {
    background-color: ${colors.feedbackColorInfoLight};
    border: ${border.width.widthHairline} solid;
    border-color: ${colors.feedbackColorInfoDark};
  }

  &.newsShort {
    background-color: ${colors.neutralColorHighPure};
    border: ${border.width.widthHairline} solid;
    border-color: ${colors.neutralColorHighMedium};
  }

  &.negative {
    background-color: ${colors.feedbackColorNegativeLight};
    border: ${border.width.widthHairline} solid;
    border-color: ${colors.feedbackColorNegativePure};
  }

  &.alert {
    background-color: ${colors.feedbackColorWarningLight};
    border: ${border.width.widthHairline} solid;
    border-color: ${colors.feedbackColorWarningDark};
  }
`
export const Text = styled.div`
  &.neutral,
  &.info,
  &.negative,
  &.alert {
    > p {
      margin-top: ${layout.margin.spacingNone};
      margin-bottom: ${layout.margin.spacingNone};
    }
  }

  &.newsShort {
    margin-bottom: ${layout.margin.spacingNone};
  }
`

export const ContainerTitle = styled.div`
  display: flex;

  > button:last-child {
    margin-left: auto;
  }
`

export const ContainerNewsShort = styled.div`
  display: flex;
  justify-content: space-between;
  > p {
    margin: ${layoutV2.spacing.micro} ${layoutV2.spacing.xmc};
    padding-top: ${layoutV2.spacing.nano};
  }

  > button {
    margin-left: ${layout.margin.spacingNano};
    margin-right: ${layout.margin.spacingNano};
  }
`

export const ContainerContent = styled.div`
  display: block;
  padding: ${layoutV2.spacing.none};

  &.has-icon {
    &.neutral,
    &.info,
    &.negative,
    &.alert {
      padding: ${layout.padding.spacingInsetNone}
        ${layout.padding.spacingInsetXl} ${layout.padding.spacingInsetNone}
        ${layout.padding.spacingInsetXl};
    }
  }

  &.newsShort {
    padding-left: ${layout.padding.spacingInsetNone};
  }
`

export const Title = styled.p`
  font-weight: ${typography.fontWeight.fontWeightBold};
  font-size: ${typography.fontSize.fontSizeXxs};
  margin-top: ${layoutV2.spacing.xxmc};
`

export const ContainerClose = styled.button`
  justify-content: right;
  display: flex;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  outline: none;
  > div {
    margin-top: ${layout.margin.spacingNano};
  }
`

export const Cta = styled.a.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.brandColors.primaryDark};
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  font-size: ${typography.fontSize.fontSizeXxs};
  cursor: pointer;
  line-height: ${typography.fontHeight.lineHeightSm};
`

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
`

export const ContainerIcon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  border: ${border.width.widthThin} solid ${colors.neutralColorHighPure};
  background-color: ${colors.neutralColorHighPure};
  border-radius: ${border.radius.radiusCircular};
  margin-right: ${layoutV2.spacing.micro};
  box-shadow: 0 0.4rem 0.8rem 0 rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NewTag = styled.div`
  margin-top: ${layout.margin.spacingNano};
  width: 59px;
  height: 26px;
  align-items: center;
  line-height: ${typography.fontHeight.lineHeightSm};
  border: ${border.width.widthThin} solid ${colors.brandColorPrimaryLight};
  background-color: ${colors.brandColorPrimaryLight};
  border-radius: 2rem;
  box-sizing: border-box;
  display: flex;
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightRegular};
  font-size: ${typography.fontSize.fontSizeXxxs};
  justify-content: center;
  padding: 0.4rem 1.2rem 0.4rem 1.2rem;
  text-transform: uppercase;
  color: ${colors.brandColorPrimaryPure};
`

export const ContainerCta = styled.div`
  margin-top: ${layout.margin.spacingXxxs};
`
